var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9349 13.1906C24.9349 20.0584 19.3674 25.6259 12.4996 25.6259C5.63171 25.6259 0.064209 20.0584 0.064209 13.1906C0.064209 6.32269 5.63171 0.755188 12.4996 0.755188C19.3674 0.755188 24.9349 6.32269 24.9349 13.1906ZM1.57006 13.1906C1.57006 19.2268 6.46337 24.1201 12.4996 24.1201C18.5358 24.1201 23.4291 19.2268 23.4291 13.1906C23.4291 7.15435 18.5358 2.26104 12.4996 2.26104C6.46337 2.26104 1.57006 7.15435 1.57006 13.1906Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0146 13.7021C18.2246 13.5808 18.2246 13.2778 18.0146 13.1566L10.3379 8.72437C10.1279 8.60315 9.86544 8.75467 9.86544 8.99712V17.8615C9.86544 18.104 10.1279 18.2555 10.3379 18.1343L18.0146 13.7021Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/Video Icon.ebd22a1332246109a844508bc74ef666.svg";
export { ForwardRef as ReactComponent };